import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLngs } from 'i18n';
import { IDropdownItem } from 'types';
import { BasicDropdown } from 'components';
import styles from './LanguageSelect.module.scss';
import pakFlag from '../../../../resources/images/flags/pakistan-fag.png'; // Note: Fix typo in 'pakistan-fag.png' to 'pakistan-flag.png'
import englandFlag from '../../../../resources/images/flags/england-flag.png';
import spainFlag from '../../../../resources/images/flags/spain-flag.png';

const LanguageSelectView = () => {
  const { t, i18n } = useTranslation();

  // Map language codes to flag images
  const flagMap: Record<string, string> = {
    en: englandFlag,
    es: spainFlag,
    ur: pakFlag,
  };

  const items = useMemo<Array<IDropdownItem>>(() => {
    return supportedLngs.map((lang) => ({
      content: (
        <div className={styles.langItem}>
          <img src={flagMap[lang]} alt={`${lang} flag`} className={styles.flag} />
          {t(`${lang}`)} {/* Keep language name if you want it alongside the flag */}
        </div>
      ),
      onClick: () => i18n.changeLanguage(lang),
    }));
  }, [t, i18n]);

  return (
    <div className={styles.container}>
      <BasicDropdown name='LanguageSelect' items={items} placement='bottomCenter' isCaretOutside>
        {/* Show selected language with flag inside the button */}
        <div className={styles.selectedLang}>
          <img src={flagMap[i18n.language]} alt={`${i18n.language} flag`} className={styles.flag} />
          {t(`${i18n.language}`)} {/* Keep language name if desired */}
        </div>
      </BasicDropdown>
    </div>
  );
};

export default LanguageSelectView;
